import React from "react";

export type BadgeStatus = "Active" | "Passive" | "Deleted";

interface StatusBadgeProps {
  status: BadgeStatus;
  className?: string;
  style?: React.CSSProperties;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  className,
  style,
}) => {
  const statusConfig = {
    Active: {
      backgroundColor: "#ECFDF3",
      color: "#067647",
      text: "Active",
      borderColor: "#ABEFC6",
    },
    Passive: {
      backgroundColor: "#FAFAFA",
      color: "#414651",
      text: "Passive",
      borderColor: "#E9EAEB",
    },
    Deleted: {
      backgroundColor: "#e2e3e5",
      color: "#383d41",
      text: "Deleted",
      borderColor: "#E9EAEB",
    },
  };

  const config = statusConfig[status] || statusConfig.Passive;

  const defaultStyle: React.CSSProperties = {
    backgroundColor: config.backgroundColor,
    color: config.color,
    padding: "4px 12px",
    borderRadius: "100px",
    fontSize: "12px",
    fontWeight: "500",
    display: "inline-block",
    minWidth: "60px",
    textAlign: "center",
    border: `1px solid ${config.borderColor}`,
    ...style,
  };

  return (
    <span className={className} style={defaultStyle}>
      {config.text}
    </span>
  );
};

export default StatusBadge;

